<template>
  <div class="form-check form-switch form-check-custom form-check-success form-check-solid" :class="this.class">
    <label v-if="placeholderSecondary" class="form-check-label me-2" :for="id" v-html="this.placeholderSecondary" :class="isTitleColor && !modelValue ? 'text-primary' : ''"></label>
    <input
        :disabled="disabled"
        :checked="Boolean(modelValue)"
        :value="Boolean(modelValue)"
        :class="size"
        :name="name"
        :id="id"
        class="form-check-input"
        type="checkbox"
        @input="this.$emit('update:modelValue', Boolean(!modelValue))"
    />
    <label class="form-check-label" :for="id" v-html="this.placeholder" :class="isTitleColor && modelValue ? 'text-primary' : ''"></label>
  </div>
</template>

<script>
export default {
  name: 'SwitchBoxField',
  props: {
    placeholder: null,
    placeholderSecondary: null,
    isTitleColor: false,
    modelValue: '',
    disabled: null,
    class: null,
    name: null,
    size: 1,
    id:null
  }
}
</script>

<style scoped>

</style>